import React from 'react';
import { Section } from './ui/Section';
import { Check } from 'lucide-react';
export function BridgeSection() {
  return <Section className="bg-navy text-white text-center" data-id="element-1">
      <h2 className="text-2xl md:text-3xl font-bold mb-8" data-id="element-2">
        Lo que necesitas no es más información
      </h2>

      <div className="max-w-2xl mx-auto bg-white/5 rounded-2xl p-8 border border-white/10 backdrop-blur-sm" data-id="element-3">
        <p className="text-lg md:text-xl mb-6 font-medium" data-id="element-4">
          Necesitas un sistema que te diga:
        </p>

        <ul className="space-y-4 text-left inline-block mx-auto" data-id="element-5">
          {['Cuánto cambiar', 'Cuándo avanzar', 'Cuándo pausar', 'Cuándo retroceder', 'Qué hacer si "se desordena"'].map((item, i) => <li key={i} className="flex items-center gap-3 text-cream/90 text-lg" data-id="element-6">
              <span className="bg-green rounded-full p-1" data-id="element-7">
                <Check className="h-4 w-4 text-white" data-id="element-8" />
              </span>
              {item}
            </li>)}
        </ul>

        <div className="mt-8 pt-8 border-t border-white/10" data-id="element-9">
          <p className="text-xl font-bold text-green" data-id="element-10">
            Sin miedo. Sin drama. Sin convertirte en experta.
          </p>
        </div>
      </div>
    </Section>;
}